import React from 'react'
import { Box, Tabs, Tab, useTheme, useMediaQuery, Skeleton } from "@mui/material"
import "./style.css";

const MenuCategories = ({ categories, activeCategory, onCategoryChange, isLoading = false }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  if (isLoading) {
    return (
      <Box className='menu-category-slider-container'>
        <Box className='menu-category-skeleton-container'>
          {[...Array(6)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={isMobile ? 70 : 200}
              height={48}
              className='category-skeleton'
            />
          ))}
        </Box>
      </Box>
    )
  }
  
  return (
    <Box className='menu-category-slider-container'>
      <Tabs
        value={activeCategory}
        onChange={(_, newValue) => onCategoryChange(newValue)}
        variant="scrollable"
        scrollButtons={isMobile ? "auto" : false}
        TabIndicatorProps={{
          style: {
            backgroundColor: "#000",
            height: 3,
          },
        }}
        sx={{
          "& .MuiTabs-scroller": {
            overflowX: "auto !important",
          },
          "& .MuiTab-root": {
            color: "#999",
            fontWeight: 700,
            fontSize: isMobile ? "0.75rem" : "0.9rem",
            textTransform: "uppercase",
            minWidth: "auto",
            px: isMobile ? 1 : 2,
            py: 1,
            mr: 1,
          },
          "& .Mui-selected": {
            color: "#000",
            fontWeight: 700,
          },
        }}
      >
        {categories?.filter((category) => category?.active_status)?.map((category) => (
          <Tab key={category?.id} label={category?.name} value={category?.name} disableRipple />
        ))}
      </Tabs>
    </Box>
  )
}

export default MenuCategories
